// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/SyncAction/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Medical_Content_SyncAction($patient_id: uuid!, $organization_id: uuid!) {
  medical_histories_sync_answers(
    patient_id: $patient_id
    organization_id: $organization_id
  ) {
    id
    answer_ids
  }
}

`